module.exports = __webpack_public_path__ + "img/close.554f78b0.svg";